import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

//if environment production, and url includes "staging", set sentry env to staging
let sentryEnvironment = environment.production ? "production" : "development";  
if (environment.production && window.location.href.includes("stg.improvation.us")) {
    sentryEnvironment = "staging";
}

Sentry.init({
  dsn: "https://97ba90d98b049e32e0a6cb95f74ec48d@sentry.improvation.us/5",
  environment: sentryEnvironment,
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
      maskAllInputs: false
    }),
    Sentry.browserTracingIntegration()

  ],
  // Session Replay
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0
});

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .then(success => console.log(`Bootstrap success`))
    .catch(err => console.error(err));
